import ENUM from './enum'
import { getSubAccountList } from '@/api/domain/finance'
import { limitMoreZero } from '@/utils/validate'
import { operateMaxShowLength } from '@/store/dict/config'

export default function config() {
  return {
    configData: {
      formData: {
        list: [
          {
            el: 'input',
            itemConfig: {
              label: '账户ID',
              prop: 'accountId',
            },
            elConfig: {
              maxLength: 20,
              events: {
                input: (e) => {
                  limitMoreZero(e, (val) => {
                    this.$set(this.configData.formData.formProps.model, 'accountId', val)
                  }, 20, false)
                },
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '公司主体全称',
              prop: 'merchantName',
            },
            elConfig: {
              maxLength: 100,
              events: {
                input: this.merchantNameEvents,
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '开户状态',
              prop: 'openState',
            },
            elConfig: {
              options: {
                label: 'label',
                value: 'value',
                list: this.dictParseList(ENUM.OPEN_STATE),
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '启用状态',
              prop: 'state',
            },
            elConfig: {
              options: {
                label: 'label',
                value: 'value',
                list: this.dictParseList(ENUM.STATE),
              },
            },
          },
        ],
        formProps: {
          model: {
            channelType: '',
          },
        },
      },
      tableData: {
        columns: [
          {
            name: 'accountId',
            columnProps: {
              prop: 'accountId',
              label: '账户ID',
              minWidth: 150,
            },
          },
          {
            name: 'merchantName',
            columnProps: {
              label: '公司主体全称',
              prop: 'merchantName',
              minWidth: 180,
            },
          },
          {
            name: 'licenceNo',
            columnProps: {
              label: '统一社会信用代码证号',
              prop: 'licenceNo',
              minWidth: 180,
            },
          },
          {
            name: 'bankCardNo',
            columnProps: {
              label: '提现银行卡号',
              prop: 'bankCardNo',
              minWidth: 150,
            },
            render: ({ row }) => {
              if (row.bankCardNo) {
                return this.$createElement('span', {}, row.bankCardNo)
              }
              if (row.openState === ENUM.OPEN_STATE_ENUM.failed) {
                return '--'
              }
              return this.$createElement('span', { style: 'color: red' }, '未绑卡')
            },
          },
          {
            name: 'bankShortName',
            columnProps: {
              label: '提现银行卡开户行',
              prop: 'bankShortName',
              minWidth: 180,
            },
            render: ({ row }) => {
              if (row.bankShortName) {
                return this.$createElement('span', {}, row.bankShortName)
              }
              if (row.openState === ENUM.OPEN_STATE_ENUM.failed) {
                return '--'
              }
              return this.$createElement('span', { style: 'color: red' }, '未绑卡')
            },
          },
          {
            name: 'openState',
            columnProps: {
              label: '开户状态',
              prop: 'openState',
            },
            getText: ({ row }) => ENUM.OPEN_STATE[row.openState],
          },
          {
            name: 'state',
            columnProps: {
              label: '启用状态',
              prop: 'state',
            },
            getText: ({ row }) => ENUM.STATE[row.state],
          },
          {
            name: 'operate',
            columnProps: {
              label: '操作',
              width: 240,
              fixed: 'right',
            },
            maxShowLength: operateMaxShowLength,
            type: 'operate',
            getOperateList: ({ row }) => {
              const result = []
              // openState 开户状态枚举 2 开户中 3 开户成功 4 开户失败
              if (this.checkBankChannelPermission('startPartnerAccount', 'startPartnerAccountWangshang', this.bankChannelType) && row.state === ENUM.STATE_ENUM.disable && row.openState !== 4) {
                result.push({ name: 'startPartnerAccount', label: '启用', action: () => this.handleState(row) })
              }
              if (this.checkBankChannelPermission('endPartnerAccount', 'endPartnerAccountWangshang', this.bankChannelType) && row.state === ENUM.STATE_ENUM.enable) {
                result.push({ name: 'endPartnerAccount', label: '停用', action: () => this.handleState(row) })
              }
              if (this.checkBankChannelPermission('editPartnerAccount', 'editPartnerAccountWangshang', this.bankChannelType)) {
                result.push({ name: 'editPartnerAccount', label: '编辑', action: () => this.editAccount(row) })
              }
              if (this.checkBankChannelPermission('partnerAccountOpen', 'partnerAccountOpenWangshang', this.bankChannelType) && !([2, 3].includes(row.openState))) {
                result.push({ name: 'accountOpen', label: '开户', action: () => this.openAccount(row) })
              }
              if (this.checkBankChannelPermission('partnerAccountBindBankCard', 'partnerAccountBindBankCardWangshang', this.bankChannelType) && !row.bankCardNo) {
                result.push({ name: 'bindBankCard', label: '绑定银行卡', action: () => this.bindCardState(row, 'bindBankCard') })
              }
              if (this.checkBankChannelPermission('partnerAccountReplaceBindBankCard', 'partnerAccountReplaceBindBankCardWangshang', this.bankChannelType) && row.bankCardNo) {
                result.push({ name: 'replaceBankCard', label: '更换银行卡', action: () => this.bindCardState(row, 'changeBankCard') })
              }
              return result
            },
          },
        ],
        defaultParams: {
          type: 2, // 合作方账户开通页type为2
        },
        apiFn: getSubAccountList,
      },
      isShowDepartment: false,
    },
  }
}
